import request from "@/utils/request";

export default function listByProductId(productId) {
    return request({
        url: `/specificationValueRepository/listByProductId/`+productId,
        method: 'get',
    })
}
